import { MakerCheckerItem } from "../types/approval.types";

export const formatMoney = (value: number): string => {
  const formatter = new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency: 'TRY',
  });
  return formatter.format(value);
};

export const formatMoneyForTable = (value: number, currency: string): string => {
  const formatter = new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency: currency === 'TL' ? 'TRY' : currency,
  });
  return formatter.format(value);
};

export const currencyToForm = (currencyId: number): string => {
  let currency = 'TL';
  if (currencyId === 2) {
    currency = 'USD';
  }
  if (currencyId === 3) {
    currency = 'EUR';
  }
  if (currencyId === 4) {
    currency = 'AU';
  }
  return currency;
};

export const typeToDescription = (data: MakerCheckerItem): string => {
  
  if (data.type === 8 && data.reflectionType === 'FastOutgoingMessagesDto') return 'Fast Anlık Ödeme';
  if (data.type === 1 && data.reflectionType === 'SendMoneyListDto') return 'Cüz->Cüz';
  if (data.type === 3 && data.reflectionType === 'WithdrawalDto') return 'Cüz->Bank';
  if (data.type === 1 && (data.reflectionType === 'BulkSendMoneyListWithWalletNoDto' || data.reflectionType === 'BulkSendMoneyListWithPhoneNoDto')) return 'Hesaptan Hesaba Toplu Para Transferi';
  if (data.type === 36 && (data.reflectionType === 'BulkSendMealAllowanceListWithWalletNoDto' || data.reflectionType === 'BulkSendMealAllowanceListWithCardNoDto')) return 'Toplu Yemek Ödemesi';
  if (data.type === 36 && data.reflectionType === 'BulkSendMealAllowanceList') return 'Toplu Yemek Parası İade Et';
  if (data.type === 7 && data.reflectionType === 'BulkSendCashbackListDto') return 'Toplu Nakit İadesi';
  return '';
};

export const paymentPurpose = (value: string): string => {
  switch (value) {
    case '01':
      return 'Konut Kirası Ödemesi';
    case '02':
      return 'İş yeri Kirası Ödemesi';
    case '03':
      return 'Diğer Kira Ödemesi';
    case '04':
      return 'E-Ticaret Ödemesi';
    case '05':
      return 'Çalışan Ödemesi';
    case '06':
      return 'Ticari ödeme';
    case '07':
      return 'Bireysel Ödeme';
    case '08':
      return 'Yatırım';
    case '09':
      return 'Finansal';
    case '10':
      return 'Eğitim ödemesi';
    case '11':
      return 'Aidat ödemesi';
    default:
      return '';
  }
};
